import { useEffect } from 'react'
import { useToast } from 'src/provider/ToastContextProvider'

export function useToastCallFromApp() {
  const { openToast } = useToast()

  useEffect(() => {
    const callToastPopupHandler = function () {
      window.SaturnIosInterface = {
        ...window.SaturnIosInterface,
        handleCallToastPopup: (message: string) => {
          openToast({ contents: message })
        },
      }
      window.removeEventListener('click', callToastPopupHandler)
    }
    window.addEventListener('click', callToastPopupHandler)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
